import {
	API_END,
	API_ERROR,
	API_START,
	API_SUBMIT_END,
	API_SUBMIT_START,
	API_SUCCESS,
	SET_QUERY,
	SET_TAB,
	TOGGLE_FILTER,
	TOGGLE_MODAL,
	TOGGLE_MODAL_EM,
} from './types';

const initialState = {
	query: '',
	modal: false,
	filter: true,
	tab: 1,
	loadingSubmit: false,
	loading: false,
	modalEM: false
};

const apiReducer = (state = initialState, action) => {
	switch (action.type) {
		case API_START:
			return {
				...state,
				loading: true,
			};
		case API_END:
			return {
				...state,
				loading: false,
			};
		case API_ERROR:
			return {
				...state,
				error: action.error,
			};
		case API_SUCCESS:
			return {
				...state,
				success: action.success,
			};
		case SET_QUERY:
			return {
				...state,
				query: action.query,
			};
		case API_SUBMIT_START:
			return {
				...state,
				loadingSubmit: true,
			};
		case API_SUBMIT_END:
			return {
				...state,
				loadingSubmit: false,
			};
		case TOGGLE_MODAL:
			return {
				...state,
				modal: !state.modal,
			};
		case TOGGLE_MODAL_EM:
			return {
				...state,
				modalEM: !state.modalEM
			}
		case TOGGLE_FILTER:
			return {
				...state,
				filter: !state.filter,
			};
		case SET_TAB:
			return {
				...state,
				tab: action.tab,
			};
		default:
			return state;
	}
};

export default apiReducer;
